import { log } from './log';

export function trackSchedulerEvent()
{
    log('info', 'lifecycle::trackSchedulerEvent');
}
